import React, { useState, useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { getListRequest, getStatusDescription, cancelRequest } from '../../actions/request'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import NotInterestedIcon from '@material-ui/icons/NotInterested'
import Button from 'react-bootstrap-button-loader'
import { IsEnglish } from '../../utils/language'
import * as cancelationStatus from '../../scripts/CancelationRequestStatusCode'
import i18next from 'i18next'
import { withNamespaces } from 'react-i18next'
import AlertAlgo from '../controls/AlertSnack'
import PropTypes from 'prop-types'
import * as requestTypeCode from '../../scripts/RequestTypeCode'
import * as leaveRequestStatusCode from '../../scripts/LeaveRequestStatusCode'
import RequestDetail from './RequestDetail'
import styles from '../../styles/request.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import * as pageSourceCode from '../../scripts/PageSourceCode';
import { faPlaneEngines, faLoader, faUserClock, faCircleXmark } from "@fortawesome/pro-duotone-svg-icons";

const useStyles = makeStyles((theme) => ({
    divCell: {
        '& > .MuiAccordionSummary-content': {
            display: 'table',
            width: '100%',
        }
    },
    firstCell: {
        width: '20%',
        textAlign: 'left',
        height: '35px',
        float: 'left',
        '& > .MuiIconButton-root': {
            padding: 'unset !important',
            marginLeft: '0px !important'
        }
    },
    secondCell: {
        width: '40%',
        textAlign: 'left',
        fontWeight: 'bold',
        float: 'left'
    },
    thirdCell: {
        textAlign: 'left',
        float: 'right'
    },
    fourthCell: {
        width: '100%',
        textAlign: 'left',
        display: 'table',
        fontSize: '14px'
    },
    iconCancel: {
        color: 'red'
    },
    noBorder: {
        borderBottom: '0px!important'
    },
    status: {
        fontWeight: 'bold'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        color: 'var(--color1)!important'
    },
    cancelButton: {
        color: '#e109098a !important',
        width: "25px",
        height: "25px",
        "--fa-primary-color": "rgb(231, 122, 122)",
        "--fa-secondary-color": "rgb(231, 122, 122)"
    },
    divListRequest: {
        width: '100%',
        textAlign: 'center'
    },
    typeIconContainer: {
        marginRight: "10px",
        alignSelf: "center"
    },
    typeIcon: {
        fontSize: "25px",
        color: 'var(--color1)'
    }
}));

function ListRequestItems(props) {
    const [data, setData] = useState(null);
    const [dataRow, setDataRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [messageCancelationConfirm, setMessageCancelationConfirm] = React.useState(null);
    const [openConfirmCancelation, setOpenConfirmCancelation] = React.useState(false);
    const [cancelationId, setCancelationId] = React.useState(null);
    const [statusRequest, setStatusRequest] = React.useState(null);
    const [isApprovedRequest, setIsApprovedRequest] = React.useState(null);
    const [isActive, setIsActive] = React.useState(true);
    const [isPosting, setIsPosting] = React.useState(false);
    const [confirmTitle, setConfirmTitle] = React.useState("");

    const { filter } = props;

    useEffect(() => {
        resizeForm();
    }, [])

    useEffect(() => {
        loadPage();
    }, [filter])

    useEffect(() => {
        if (props.isReload) {
            setData(null);
            loadPage();
        }
    }, [props.isReload, filter])

    const loadPage = () => {
        if (filter != null && filter.typeRequest !== undefined && filter.typeRequest !== null) {
            loadData();
        }
    }

    const resizeForm = () => {
        // props.resizeForm is a custom function that is passed from the parent component to resize the form
        if (props.resizeForm != undefined && props.resizeForm != null) {
            props.resizeForm();
            return;
        }

        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
            const element = document.querySelector('#divListRequest');
            const offSet = 114;

            const customHeight = height - header - titleBar - offSet;

            if (element !== null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
        }, 1000);
    }

    const loadData = async () => {
        setIsActive(true);

        let typeRequest = filter.typeRequest;
        let status = filter.status;

        // default
        if (typeRequest === undefined || typeRequest === null) {
            typeRequest = [requestTypeCode.Type_Leave, requestTypeCode.Type_Vacation];
        }

        if (status === undefined || status === null) {
            status = [leaveRequestStatusCode.Status_Opened, leaveRequestStatusCode.Status_Cancel_Request];
        }

        if (typeRequest.length === 0 || status.length === 0) {
            setData(null);
            setIsActive(false);
            return;
        }

        // topSelect = 0 => all
        let topSelect = 0;

        if (props.type == pageSourceCode.PageSource_RequestRecentHistory) {
            // Recent history get only top 5 records
            topSelect = 5;
        }
        const result = await getListRequest(status, typeRequest, topSelect);

        if (result !== undefined) {
            let list = await formatList(result.list);

            setData(list);
            setIsActive(false);
        }
    }

    const formatList = async (data) => {
        return new Promise(async (resolve) => {
            const list = [];
            data.forEach((item) => {
                item.statusDescription = getStatusDescription(item.status);
                list.push(item);
            });

            resolve(list);
        })
    }

    const handleCancelRequest = async () => {
        setIsPosting(true);

        const result = await cancelRequest(cancelationId, statusRequest, isApprovedRequest);

        if (result === undefined) {
            // Error
            alertRef.current.showMessageError(i18next.t('error:generic-error'));
            setIsPosting(false);
            return;
        } else if (result.statusCode === -2) {
            alertRef.current.showMessageWarning(i18next.t('request:message.cancelation.status-changed'));
            setIsPosting(false);
            return;
        }

        alertRef.current.showMessageSuccess(i18next.t('request:message.cancelation.success'));
        handleCloseConfirmCancelation();
        loadData();
        setIsPosting(false);
    }

    const handleOpenConfirmCancelation = (event, id, statusCancelation, status, isApproved, description) => {
        event.preventDefault();
        event.stopPropagation();

        let message = '';
        setConfirmTitle(i18next.t('approvalCentral:dialog.attention'));

        if (statusCancelation === cancelationStatus.Status_Cancelable) {
            message = `${i18next.t("request:message.cancelation.cancel-demand")} ${description.toLowerCase()}?`;
            setCancelationId(id);
            setStatusRequest(status);
            setIsApprovedRequest(isApproved);

            setConfirmTitle(i18next.t('request:dialog.title'));
        } else if (statusCancelation === cancelationStatus.Status_Start_Passed) {
            message = i18next.t("request:message.cancelation.startDate-passed");
        } else if (statusCancelation === cancelationStatus.Status_Substitute_Assigned) {
            message = i18next.t("request:message.cancelation.substitute-assigned");
        } else if (statusCancelation === cancelationStatus.Status_Not_Cancelable) {
            message = i18next.t("request:message.cancelation.cannot-cancel");
        } else {
            // Error
            return;
        }

        setMessageCancelationConfirm(message);

        setOpenConfirmCancelation(true);
    }


    const handleCloseConfirmCancelation = () => {
        setCancelationId(null);
        setStatusRequest(null);
        setIsApprovedRequest(null);
        setOpenConfirmCancelation(false);
    }

    const classes = useStyles();

    const alertRef = useRef(null);

    const handleClick = (obj) => {
        setDataRow(obj);
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div id="divListRequest" data-type={props.type} className={styles.konekCard + ' ' + classes.divListRequest}>
            {data != null && data.map((obj, index) =>
                <React.Fragment key={index}>
                    <ListItem key={index} button className="listItem" onClick={() => handleClick(obj)}>
                        <ListItemText disableTypography={true} primary={
                            <React.Fragment>
                                <div style={{ display: "flex" }}>
                                    <div className={classes.typeIconContainer}>
                                        {obj.request.requestType == "V" &&
                                            <FontAwesomeIcon icon={faPlaneEngines} className={classes.typeIcon} />
                                        }
                                        {obj.request.requestType == "C" &&
                                            <FontAwesomeIcon icon={faUserClock} className={classes.typeIcon} />
                                        }
                                    </div>
                                    <div style={{flex: "1"}}>
                                        <div className={classes.divCell}>
                                            <div>
                                                <div className={classes.secondCell}>{IsEnglish() ? obj.requestTypeEn : obj.requestTypeFr}</div>
                                                <div className={classes.thirdCell}>
                                                    {obj.status == 'O' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusOpen}>{obj.statusDescription}</span>
                                                    }
                                                    {obj.status == 'F' && obj.isApproved &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusApproved}>{i18next.t('approvalCentral:status.approved')}</span>
                                                    }
                                                    {obj.status == 'F' && !obj.isApproved &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusDenied}>{i18next.t('approvalCentral:status.refused')}</span>
                                                    }
                                                    {obj.status == 'D' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusCancellationRequest}>{i18next.t('approvalCentral:status.cancelation')}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className={classes.fourthCell}>{IsEnglish() ? obj.descriptionEn : obj.descriptionFr}</div>
                                    </div>
                                </div>
                            </React.Fragment>
                        } />
                        <ListItemSecondaryAction className={classes.divAction}>
                            {obj.isAnnulable !== cancelationStatus.Status_Not_Cancelable_HiddenCancelButton &&
                                <IconButton edge="start" color="inherit" onClick={(event) => handleOpenConfirmCancelation(event, obj.centralApprovalId, obj.isAnnulable, obj.status, obj.isApproved, IsEnglish() ? obj.descriptionEn : obj.descriptionFr)} aria-label="close">
                                    <FontAwesomeIcon icon={faCircleXmark} className={classes.cancelButton} />
                                </IconButton>}
                        </ListItemSecondaryAction>
                    </ListItem>
                </React.Fragment>
            )}
            {isActive && <FontAwesomeIcon icon={faLoader} style={{ fontSize: "55px" }} spin />}
            {dataRow != null && <RequestDetail open={open} onClose={handleClose} data={dataRow} />}
            <Dialog
                open={openConfirmCancelation}
                onClose={handleCloseConfirmCancelation}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    {confirmTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {messageCancelationConfirm}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {cancelationId > 0 &&
                        <Button loading={isPosting} autoFocus onClick={handleCancelRequest} color="primary" className={styles.defaultButton} variant="success">
                            {i18next.t('buttons:yes')}
                        </Button>}
                    {cancelationId > 0 &&
                        <Button onClick={handleCloseConfirmCancelation} color="primary" className={styles.defaultButton} variant="success">
                            {i18next.t('buttons:no')}
                        </Button>}
                    {cancelationId === null && <Button onClick={handleCloseConfirmCancelation} color="primary" className={styles.defaultButton} variant="success">
                        {i18next.t('buttons:close')}
                    </Button>}
                </DialogActions>
            </Dialog>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['request', 'buttons', 'error', 'approvalCentral'], { wait: true })(ListRequestItems);

ListRequestItems.propTypes = {
    filter: PropTypes.object.isRequired
}